import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";

const UserRoleService = {

    async update(data: {
        clientId: string,
        organizationId: string,
        userId: string,
        roleCodes: string[],
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.USER_ROLE.UPDATE, data);
        return result.data;
    }
}

export default UserRoleService